<template>
  <div class="results">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button
        v-if="plan"
        @click="newUser()"
        class="btn fixed_btn"
        :class="{
          user_limit:
            usage.employees + usage.visitors >= plan.users &&
            plan.users != 'unlimited',
        }"
      >
        NEW {{ source.toUpperCase() }}
        <template>
          <span v-if="plan.users != 'unlimited'" class="count"
            >{{ usage.employees + usage.visitors }} / {{ plan.users }}</span
          >
        </template>
      </button>
      <div class="card">
        <p class="title">
          {{ source.toUpperCase() }}S
          <button
            class="btn round-btn img-btn"
            @click="$router.push(`/scheduled-reminders/${source}s`)"
          >
            <img src="@/assets/img/clock.svg" />
            Scheduled Reminders
          </button>
        </p>
        <div class="action_btns">
          <div class="filter">
            <sub>Search</sub>
            <div class="inputs survey-forms">
              <div class="input full">
                <input
                  :placeholder="`Search by First & Last Name, Email, Phone${
                    source == 'employee' ? ', Employee (ID/Number)' : ''
                  }`"
                  type="text"
                  @keyup="handleSearch"
                />
              </div>
            </div>
            <sub>Filter by Location</sub>
            <div class="inputs survey-forms">
              <div class="input full">
                <v-select
                  :options="locations"
                  label="name"
                  :clearable="false"
                  :reduce="(d) => d.id"
                  v-model="filter_values.location"
                  @input="
                    () => {
                      (this.filteredAmount = 0), moveToPage(0);
                    }
                  "
                >
                  <template v-slot:option="option">
                    <div>
                      {{
                        `${option.name} - ${option.address_1}, ${option.city}, ${option.state}`
                      }}
                    </div>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="inputs survey-forms">
              <sub>Filter by Department</sub>
              <div class="input full">
                <v-select
                  :options="departments"
                  label="name"
                  :clearable="false"
                  :reduce="(d) => d.id"
                  v-model="filter_values.department"
                  @input="
                    () => {
                      (this.filteredAmount = 0), moveToPage(0);
                    }
                  "
                ></v-select>
              </div>
            </div>
            <div class="inputs survey-forms">
              <button
                v-if="showClearBtn"
                @click="clearFilter"
                class="btn round-btn red"
              >
                Clear Filter
              </button>
            </div>
          </div>
          <div class="filters">
            <button @click="showScheduledPopup" class="btn round-btn">
              Schedule All
            </button>
            <button @click="inputFileToExport" class="btn round-btn">
              Export
            </button>
            <button @click="showImportPopup" class="btn round-btn">
              Import
            </button>
            <button @click="$refs.uploadDelete.click()" class="btn round-btn">
              Import Bulk Delete
            </button>
            <div
              class="btn-helper"
              @mouseover="helper = true"
              @mouseout="helper = false"
            >
              <button
                class="text_btn btn text"
                @click="downloadTemplate"
                style="cursor: pointer; text-decoration: underline"
              >
                Download Example CSV Templates
              </button>
              <transition name="fade">
                <div v-if="helper" class="helper">
                  <p>
                    You can download an example csv template which you can fill
                    out with your own employee/visitor information.Your CSV
                    template must match the example templates
                    <strong>exactly</strong> as shown
                  </p>
                  <p>
                    If you are importing employees with Departments and/or
                    Employee Number(ID) use template 2. Otherwise use the
                    default template 1
                  </p>
                </div>
              </transition>
            </div>
          </div>

          <transition name="fade">
            <div class="filters mult-action" v-if="selected_users.length">
              <p>
                <span>Choose email or phone below</span>
              </p>
              <div class="filter">
                <label>Email</label>
                <div class="switch-holder">
                  <switches v-model="send_email"></switches>
                </div>
              </div>
              <div class="filter">
                <label>Phone</label>
                <div class="switch-holder">
                  <switches v-model="send_text"></switches>
                </div>
              </div>
              <button
                @click="initBulkPopup"
                :style="button_valid"
                :disabled="!delivery_types.length"
                class="btn dark round-btn reverse btn-img"
              >
                <img src="@/assets/img/send.svg" /> Send To Selected Users
              </button>

              <button
                @click="initScheduledpopup"
                :style="button_valid"
                :disabled="!delivery_types.length"
                class="btn dark round-btn reverse btn-img"
              >
                <img src="@/assets/img/schedule.svg" /> Scheduled Send
              </button>

              <button
                @click="handleVaccVerification"
                class="btn dark round-btn reverse btn-img"
              >
                <img src="@/assets/img/send.svg" /> Send Vaccine Verification To
                Selected User(s)
              </button>

              <button @click="deleteUsers" class="btn round-btn red">
                Delete {{ source }}(s)
              </button>
            </div>
          </transition>

          <input
            style="display: none"
            ref="upload"
            type="file"
            class="hide_upload"
            @change="inputFileToImport"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
          <input
            style="display: none"
            ref="uploadDelete"
            type="file"
            class="hide_upload"
            @change="inputFileToImportDelete"
            accept=".csv"
          />
        </div>
      </div>

      <div class="card table-card">
        <div class="table-holder">
          <div class="select-all">
            <input ref="selectAll" type="checkbox" @input="selectAll" />
            <span>Select All On Page</span>
          </div>
          <table>
            <thead>
              <tr>
                <th width="50"></th>
                <th>Name</th>
                <th width="150">Email</th>
                <th>Phone Number</th>
                <th>Department</th>
                <th>Location</th>
                <th v-if="source == 'employee'">Employee #</th>
                <th>Edit</th>
                <th v-if="individualSend">Send</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(user, i) in users">
                <tr :key="i" :class="{ grey: i % 2 }">
                  <td data-label="Select">
                    <input
                      :value="user"
                      v-model="selected_users"
                      type="checkbox"
                    />
                  </td>
                  <td data-label="First Name">
                    {{ `${user.first_name} ${user.last_name}` }}
                    <template v-if="user.init_reminders">
                      <span class="has-reminder">Has Reminder</span>
                    </template>
                  </td>
                  <td data-label="Email">
                    {{ user.email ? user.email : "TBD" }}
                  </td>
                  <td data-label="Phone Number" class="no-break">
                    {{ user.phone ? user.phone : "TBD" }}
                  </td>
                  <td data-label="Department">
                    {{
                      user.department
                        ? department_names[user.department]
                        : "TBD"
                    }}
                  </td>
                  <td data-label="Location">
                    {{ user.location ? location_names[user.location] : "TBD" }}
                  </td>
                  <td v-if="source == 'employee'" data-label="Employee Number">
                    {{ user.employee_number ? user.employee_number : "TBD" }}
                  </td>
                  <td class="edit" data-label="Edit">
                    <img
                      @click="goTo(`/${source}/` + user.id)"
                      class="action clickable"
                      src="@/assets/img/edit.svg"
                    />
                  </td>
                  <td class="edit" v-if="individualSend" data-label="Send">
                    <img
                      @click="selectUser(user)"
                      class="action clickable"
                      src="@/assets/img/send.svg"
                    />
                  </td>
                  <td class="edit" data-label="Delete">
                    <img
                      @click="handleDelete(user)"
                      class="action clickable"
                      src="@/assets/img/delete.svg"
                    />
                  </td>

                  <div class="mobile-editor">
                    <div class="edit-btn">
                      <img
                        @click="goTo(`/${source}/` + user.id)"
                        class="action clickable"
                        src="@/assets/img/edit.svg"
                      />
                    </div>
                    <div class="edit-btn" v-if="individualSend">
                      <img
                        @click="selectUser(user)"
                        class="action clickable"
                        src="@/assets/img/send.svg"
                      />
                    </div>
                    <div class="edit-btn">
                      <img
                        @click="handleDelete(user)"
                        class="action clickable"
                        src="@/assets/img/delete.svg"
                      />
                    </div>
                  </div>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="pagination">
          <p>
            {{ calcPaginationPageTotal }}
            <span>of</span>
            {{ calcUserAmount }} - Pg: {{ pagination.current_page }}
          </p>
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(0)"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(-1)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <!-- <div class="pages">
            <div class='action page active' >
              {{((pagination.current_page-1)*pagination.page_size)+1}}-{{pagination.current_page*pagination.page_size}} of {{usage[source+'s']}}
            </div>
          </div>-->
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage(1)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage()"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
        </div>
      </div>
    </div>

    <popup :locations="locations" @save-user-reminder="saveUserReminder">
      <template>
        <p class="title">
          Choose the location and department for the employees you are importing
        </p>
        <sub>* CSV Only</sub>
        <div
          class="btn-helper"
          @mouseover="helper = true"
          @mouseout="helper = false"
        >
          <button
            class="text_btn btn text"
            @click="downloadTemplate"
            style="cursor: pointer; text-decoration: underline"
          >
            Download Example CSV Templates
          </button>
          <transition name="fade">
            <div v-if="helper" class="helper">
              <p>
                You can download an example csv template which you can fill out
                with your own employee/visitor information.Your CSV template
                must match the example templates
                <strong>exactly</strong> as shown
              </p>
              <p>
                If you are importing employees with Departments and/or Employee
                Number(ID) use template 2. Otherwise use the default template 1
              </p>
            </div>
          </transition>
        </div>
        <br />
        <div class="inputs survey-forms">
          <transition name="fade">
            <div class="full" v-if="!importLoading">
              <sub>Locations (optional)</sub>
              <div class="input full">
                <v-select
                  :options="locations"
                  :clearable="false"
                  label="name"
                  :reduce="(d) => d.id"
                  v-model="selected_location"
                >
                  <template v-slot:option="option">
                    <div>
                      {{
                        `${option.name} - ${option.address_1}, ${option.city}, ${option.state}`
                      }}
                    </div>
                  </template>
                </v-select>
              </div>
              <br />
              <sub>Departments (Optional)</sub>
              <div class="input full">
                <v-select
                  :options="departments"
                  label="name"
                  :reduce="(d) => d.id"
                  :clearable="true"
                  v-model="selected_department"
                ></v-select>
              </div>
              <button @click="$refs.upload.click()" class="btn round-btn">
                Continue
              </button>
            </div>
          </transition>

          <transition name="fade">
            <div v-if="importLoading">
              <img class="loader" src="@/assets/img/loader.gif" />
            </div>
          </transition>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import Popup from "./Popup";
import Register from "./Register";
import firebase from "firebase";
import Swal from "sweetalert2";
import axios from "axios";
import Switches from "vue-switches";
import moment from "moment";

import { db, auth, functions, fieldValue } from "../firebaseConfig.js";

export default {
  props: ["source"],
  components: {
    register: Register,
    popup: Popup,
    Switches,
  },
  data() {
    return {
      individualSend: true,
      send_email: false,
      send_text: false,
      forms: null,
      helper: false,
      showPopup: false,
      showDeletePopup: false,
      popupType: "email",
      form: null,
      selected_user: null,
      client: null,
      users: [],
      usage: {
        forms: 0,
        visitors: 0,
        employees: 0,
        locations: 0,
        departments: 0,
      },
      locations: [],
      departments: [],
      department_names: {},
      location_names: {},
      delivery_types: [],
      filter_values: {},
      locations: null,
      loading: false,
      selected_dates: [],
      reoccurrence_type: null,
      // showClearBtn: false,
      showBulkBtn: false,
      filteredAmount: 0,
      selected_location: null,
      selected_department: null,
      selected_users: [],
      sendText: functions.httpsCallable("sendText"),
      sendEmail: functions.httpsCallable("sendSurveyLinkEmail"),
      sendVerificationEmail: functions.httpsCallable("sendVaccineVerificationEmail"),
      getEmailLink: functions.httpsCallable("getEmailLink"),
      importCSV: functions.httpsCallable("importCSV"),
      exportCSV: functions.httpsCallable("exportCSV"),
      searchForEmployee: functions.httpsCallable("algolia-searchForEmployee"),
      searchForVisitor: functions.httpsCallable("algolia-searchForVisitor"),
      scheduleAllEmployees: functions.httpsCallable("scheduleAllEmployees"),
      getEmployeesToDeleteFromCSV: functions.httpsCallable(
        "getEmployeesToDeleteFromCSV"
      ),
      deleteBulkEmployees: functions.httpsCallable("handleBulkEmployeeDelete"),
      importLoading: false,
      pagination: {
        previous_doc: null,
        next_doc: null,
        page_size: 10,
        current_page: 1,
      },
      plan: null,
      isFiltered: false,
      employeesToDelete: [],
      employeesConfirmedForDeletion: [],
      loadPageCount: false,
    };
  },
  async beforeMount() {
    if (this.$route.query.page_size) {
      this.pagination.page_size = parseInt(this.$route.query.page_size);
    }
    return this.moveToPage(0);
  },
  firestore() {
    return {
      client: db.collection("user").doc(this.user_doc.id),
      locations: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("locations"),
      departments: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("departments"),
      usage: db.collection("usage").doc(this.user_doc.id),
      forms: db.collection("user").doc(this.user_doc.id).collection("forms"),
    };
  },
  watch: {
    client() {
      this.$store.commit("setPlanId", this.client.plan_id);
      if (!this.plan) {
        this.getPlan();
      }
    },
    departments() {
      this.departments.forEach((d) => {
        this.department_names[d.id] = d.name;
      });
    },
    locations() {
      this.locations.forEach((d) => {
        this.location_names[d.id] = d.name;
      });
    },
    selected_dates() {
      let days = {
        "00": false,
        "01": false,
        "02": false,
        "03": false,
        "04": false,
        "05": false,
        "06": false,
      };
      this.selected_dates.forEach((day) => {
        days[day] = true;
      });

      this.selected_users.forEach((user) => {
        user.reminders = days;
      });
    },
    reoccurrence_type() {
      this.selected_users.forEach((user) => {
        if (this.reoccurrence_type == "Every day") {
          user.reminders = {
            "00": true,
            "01": true,
            "02": true,
            "03": true,
            "04": true,
            "05": true,
            "06": true,
          };
        } else if (this.reoccurrence_type == "Every weekday") {
          user.reminders = {
            "00": true,
            "01": true,
            "02": true,
            "03": true,
            "04": true,
            "05": false,
            "06": false,
          };
        }
      });
    },
    selected_users() {
      if (this.selected_users.length) {
        this.individualSend = false;
      } else {
        this.individualSend = true;
      }
    },
    filter_values: {
      handler(val) {
        this.filteredAmount = 0;
      },
      deep: true,
    },
  },
  computed: {
    showClearBtn() {
      return !!Object.keys(this.filter_values).length;
    },
    calcUserAmount() {
      let total = 0;
      if (this.filteredAmount && this.isFiltered) {
        total = this.filteredAmount;
      } else if (!this.isFiltered && !this.filteredAmount) {
        total = this.usage[this.source + "s"];
      }
      return total;
    },
    calcPaginationPageTotal() {
      let total =
        this.pagination.current_page +
        this.pagination.page_size * this.pagination.current_page -
        this.pagination.current_page;

      if (total > this.usage[this.source + "s"]) {
        if (this.filteredAmount && this.isFiltered) {
          total = this.filteredAmount;
        } else if (!this.isFiltered && !this.filteredAmount) {
          total = this.usage[this.source + "s"];
        }
      }
      return total;
    },
    userURL() {
      if (this.selected_user && this.form) {
        return `https://covidsurvey.web.app/${this.user_doc.id}/${this.form.id}/${this.selected_user.id}`;
      } else {
        return null;
      }
    },
    button_valid() {
      this.delivery_types = [];
      if (this.send_email) this.delivery_types.push("email");
      if (this.send_text) this.delivery_types.push("phone");
      if (this.delivery_types.length) {
        return {};
      } else {
        return { opacity: "30%", "pointer-events": "none" };
      }
    },
    confirmAllForDeletion: {
      get: function () {
        return this.employeesToDelete
          ? this.employeesConfirmedForDeletion.length ==
              this.employeesToDelete.length
          : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.employeesToDelete.forEach((e) => {
            selected.push(e.id);
          });
        }
        this.employeesConfirmedForDeletion = selected;
      },
    },
  },
  methods: {
    handleSearch(e) {
      let user_id = this.$store.state.user_doc.id;
      let query = e.target.value;
      if (!query) return this.moveToPage(0);
      if (this.source == "employee") {
        return this.searchForEmployee({
          user_id: user_id,
          query: query,
        }).then((res) => {
          this.users = res.data;
        });
      }
      if (this.source == "visitor") {
        return this.searchForVisitor({
          user_id: user_id,
          query: query,
        }).then((res) => {
          this.users = res.data;
        });
      }
    },
    getPlan() {
      let vm = this;
      if (this.client.plan_id != "admin_approved") {
        db.collection("plan")
          .doc(vm.client.plan_id)
          .get()
          .then((plan) => {
            this.plan = plan.data();
          });
      } else {
        this.plan = {
          users: "unlimited",
        };
      }
    },
    handleCheckIn(date) {
      if (!date) return false;
      let today = moment().startOf("day").valueOf();
      let last_checked_in = moment(date).startOf("day").valueOf();
      return today == last_checked_in;
    },
    downloadTemplate() {
      let outputTemplate1 = "First Name,Last Name,Email,Phone\n";
      let outputTemplate2 =
        "First Name,Last Name,Email,Phone,Employee Number,Department\n";

      let csvContent1 =
        "data:text/csv;charset=utf-8," +
        outputTemplate1 +
        `John,Doe,johndoe@support.com,(123) 123-1234` +
        "\n";

      let csvContent2 =
        "data:text/csv;charset=utf-8," +
        outputTemplate2 +
        `John,Doe,johndoe@support.com,(123) 123-1234,1234,School` +
        "\n";

      let encodedUri1 = encodeURI(csvContent1);
      let encodedUri2 = encodeURI(csvContent2);
      let template1 = document.createElement("a");
      template1.setAttribute("href", csvContent1);
      template1.setAttribute("download", `ExampleTemplate1.csv`);
      document.body.appendChild(template1); // Required for FF
      template1.click();

      let template2 = document.createElement("a");
      template2.setAttribute("href", csvContent2);
      template2.setAttribute("download", `ExampleTemplate2.csv`);
      document.body.appendChild(template2); // Required for FF
      template2.click();
    },
    async moveToPage(page) {
      let pagination = this.pagination;
      let ref = db
        .collection("user")
        .doc(this.user_doc.id)
        .collection(this.source);
      for (const key in this.filter_values) {
        if (this.filter_values.hasOwnProperty(key) && this.filter_values) {
          const element = this.filter_values[key];
          if (element) {
            ref = ref.where(`${key}`, "==", element);
          }
        }
        this.isFiltered = true;
      }

      if (this.isFiltered && !this.filteredAmount) {
        let filteredAmount = await ref.get();
        this.filteredAmount = filteredAmount.size;
      }

      if (page === -1) {
        //Previous Page
        ref = ref
          .limit(pagination.page_size)
          .orderBy("last_name", "desc")
          .startAfter(pagination.previous_doc);
      } else if (page === 1) {
        //Next Page
        ref = ref
          .limit(pagination.page_size)
          .orderBy("last_name")
          .startAfter(pagination.next_doc);
      } else if (page === 0) {
        //First page
        ref = ref.limit(pagination.page_size).orderBy("last_name");
      } else {
        //Last page
        let total;
        if (this.filteredAmount && this.isFiltered) {
          total = this.filteredAmount;
        } else if (!this.isFiltered && !this.filteredAmount) {
          total = this.usage[this.source + "s"];
        }
        let last_full_page = Math.floor(total / pagination.page_size);
        let limit = total - last_full_page * pagination.page_size;
        ref = ref
          .limit(limit || pagination.page_size)
          .orderBy("last_name", "desc");
      }
      let query = await ref.get();
      let docs = query.docs;
      if (page === -1 || page === undefined) {
        // counting down
        docs.reverse();
      }
      if (query.size === 0 && page !== 0) {
        if (page === 1) {
          this.pagination.next_doc = null;
        } else if (page === -1) {
          this.pagination.previous_doc = null;
        }
      } else {
        let users = docs.map((d) => Object.assign({ id: d.id }, d.data()));
        this.pagination.previous_doc = docs[0];
        this.pagination.next_doc = docs[docs.length - 1];
        if (page === 0) {
          this.pagination.previous_doc = null;
          this.pagination.current_page = 1;
          if (query.size < pagination.page_size) {
            this.pagination.next_doc = null;
          }
        } else if (page === undefined) {
          let total;
          if (this.filteredAmount && this.isFiltered) {
            total = this.filteredAmount;
          } else if (!this.isFiltered && !this.filteredAmount) {
            total = this.usage[this.source + "s"];
          }
          let last_full_page = Math.ceil(total / pagination.page_size);
          this.pagination.next_doc = null;
          this.pagination.current_page = last_full_page;
        } else {
          this.pagination.current_page += page;
          if (query.size < pagination.page_size) {
            this.pagination[page === -1 ? "previous_doc" : "next_doc"] = null;
          }
        }
        this.users = users;
      }
      this.pagination = Object.assign({}, this.pagination);

      return true;
    },

    saveUserReminder() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });

      if (this.popupType == "scheduled_all") {
        if (!this.reoccurrence_type) {
          Swal.fire("Please select a reoccurrence type");
          this.closePopup();
          return loader.hide();
        }

        if (!this.form) {
          Swal.fire("Please select a form");
          this.closePopup();
          return loader.hide();
        }

        if (!this.send_email && !this.send_text) {
          Swal.fire("Please select a delivery type");
          this.closePopup();
          return loader.hide();
        }

        let days = {
          "00": false,
          "01": false,
          "02": false,
          "03": false,
          "04": false,
          "05": false,
          "06": false,
        };
        this.selected_dates.forEach((day) => {
          days[day] = true;
        });
        this.showPopup = false;
        return this.scheduleAllEmployees({
          email: this.send_email,
          text: this.send_text,
          user_id: auth.currentUser.uid,
          location: this.selected_location,
          form: this.form.id,
          reoccurrence_type:
            this.reoccurrence_type !== "Select specific days of the week"
              ? this.reoccurrence_type
              : days,
        })
          .then(() => {
            loader.hide();
            this.closePopup();
            return Swal.fire(
              "Success!",
              "Successfully set schedule.",
              "success"
            );
          })
          .catch((error) => {
            this.closePopup();
            loader.hide();
            return Swal.fire(
              "Something went wrong, Please try again later",
              `${error.message}`,
              "error"
            );
          });
      } else {
        let batch = db.batch();
        let promised_arr = this.selected_users.map((user) => {
          user.init_reminders = true;
          user.form_id = this.form.id;
          user.delivery_types = {
            email: this.send_email,
            text: this.send_text,
          };

          let ref = db
            .collection(`user/${this.user_doc.id}/${this.source}`)
            .doc(user.id);
          return batch.set(ref, user, { merge: true });
        });

        return Promise.all([batch.commit()], promised_arr).then(() => {
          this.selected_users = [];
          this.selected_dates = [];
          this.reoccurrence_type = null;
          this.popupType = null;
          this.showPopup = false;
          this.form = null;
          loader.hide();
        });
      }
    },
    clearFilter() {
      this.showBulkBtn = false;
      this.filteredAmount = 0;
      this.filter_values = {};
      this.isFiltered = false;
      this.moveToPage(0);
    },
    closePopup() {
      this.selected_users = [];
      this.selected_dates = [];
      this.delivery_types = [];
      this.reoccurrence_type = null;
      this.popupType = null;
      this.showPopup = false;
      this.selected_location = null;
      this.form = null;
      this.send_email = false;
      this.send_text = false;
    },
    initBulkPopup() {
      this.showPopup = true;
      this.popupType = "bulk";
    },
    initScheduledpopup() {
      this.showPopup = true;
      this.popupType = "scheduled";
    },
    sendBulkEmail() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });

      if (this.selected_users.length) {
        let promise_arr = this.selected_users.map(async (user, index) => {
          let userURL = `https://covidsurvey.web.app/${this.user_doc.id}/${this.form.id}/${user.id}`;
          return await this.sendSurvey(user, userURL);
        });
        return Promise.all(promise_arr).then(() => {
          loader.hide();
          this.popupType = "email";
          this.loading = false;
          this.selected_users = [];
          return Swal.fire("Your survey has been sent");
        });
      }

      let ref = db.collection(`user/${this.user_doc.id}/${this.source}`);
      for (const key in this.filter_values) {
        if (this.filter_values.hasOwnProperty(key) && this.filter_values) {
          const element = this.filter_values[key];
          if (element) {
            ref = ref.where(`${key}.id`, "==", element.id);
          }
        }
      }
      return ref.get().then((query) => {
        let promise_arr = query.docs.map(async (d, index) => {
          let user = Object.assign({ id: d.id }, d.data());
          let userURL = `https://covidsurvey.web.app/${this.user_doc.id}/${this.form.id}/${user.id}`;
          return await this.sendSurvey(user, userURL);
        });
        return Promise.all(promise_arr).then(() => {
          loader.hide();
          this.popupType = "email";
          this.loading = false;
          this.selected_users = [];
          return Swal.fire("Your survey has been sent");
        });
      });
    },
    selectAll(e) {
      if (e.target.checked) {
        this.selected_users = this.users;
      } else {
        this.selected_users = [];
      }
    },
    activate(item) {
      if (this.details == item.sku) {
        this.details = null;
      } else {
        this.details = item.sku;
      }
    },
    newUser() {
      if (this.usage.employees + this.usage.visitors >= this.plan.users) {
        Swal.fire(
          "You've reached your user limit!",
          "Please upgrade your plan for more users."
        );
      } else {
        let id = db.collection(this.source).doc().id;
        this.goTo(`/${this.source}/` + id);
      }
    },
    selectUser(user) {
      this.checkLogo(user);
    },
    checkLogo(user) {
      if (this.client.logo) {
        this.checkLocations(user);
      } else {
        return Swal.fire("Please add a company logo first!").then(() =>
          this.$router.push({ path: "/profile" })
        );
      }
    },
    checkLocations(user) {
      if (this.locations.length) {
        this.selected_user = user;
        this.popupType = "email";
        this.showPopup = true;
      } else {
        return Swal.fire("Last Step! Please add a location first.").then(() =>
          this.$router.push({ path: "/locations" })
        );
      }
    },
    getAddress(user) {
      let location = this.locations.filter(function (location) {
        return location.id == user.location;
      });
      return location[0];
    },
    async sendSurvey(user, user_url) {
      this.showPopup = false;

      let selected_user = user ? user : this.selected_user;
      let userURL = user_url ? user_url : this.userURL;
      let location = await this.getAddress(selected_user);
      selected_user.location = location;
      const batch = db.batch();
      batch.update(
        db.doc(`user/${this.user_doc.id}/${this.source}/${selected_user.id}`),
        {
          "last_survey_sent.date": moment()
            .startOf("day")
            .format("DDDD, MMM Do YYYY"),
        }
      );

      let deliveries = [];
      if (this.delivery_types.includes("email") && selected_user.email) {
        batch.update(
          db.doc(`user/${this.user_doc.id}/${this.source}/${selected_user.id}`),
          { "last_survey_sent.email": fieldValue.serverTimestamp() }
        );
        deliveries.push(
          this.sendEmail({
            to_email: [
              {
                email: selected_user.email,
                type: "to",
              },
            ],
            company: this.user_doc.company,
            global_merge_vars: [
              {
                name: "logo",
                content: this.client.logo,
              },
              {
                name: "name",
                content: selected_user.first_name,
              },
              {
                name: "address",
                content: selected_user.location
                  ? selected_user.location.address_1
                  : this.locations[0].address_1,
              },
              {
                name: "city",
                content: selected_user.location
                  ? selected_user.location.city
                  : this.locations[0].city,
              },
              {
                name: "state",
                content: selected_user.location
                  ? selected_user.location.state
                  : this.locations[0].state,
              },
              {
                name: "zip",
                content: selected_user.location
                  ? selected_user.location.zip
                  : this.locations[0].zip,
              },
              {
                name: "phone",
                content: this.client.phone,
              },
              {
                name: "url",
                content: userURL,
              },
            ],
            message: null,
            uid: this.user_doc.id,
            fullName: `${selected_user.first_name} ${selected_user.last_name}`,
            employee_id: selected_user.employee_id,
          })
        );
      }
      if (this.delivery_types.includes("phone") && selected_user.phone) {
        batch.update(
          db.doc(`user/${this.user_doc.id}/${this.source}/${selected_user.id}`),
          { "last_survey_sent.text": fieldValue.serverTimestamp() }
        );
        deliveries.push(
          this.sendText({
            form: this.form.id,
            user: selected_user,
            name: selected_user.first_name + " " + selected_user.last_name,
            number: selected_user.phone,
            company: this.$store.state.user_doc.company,
            url: userURL,
            uid: this.user_doc.id,
            employee_id: selected_user.id,
          })
        );
      }
      return Promise.all(deliveries).then(() => batch.commit());
    },
    async sendVaccineVerificationEmail(user, user_url) {
      this.showPopup = false;

      let selected_user = user;
      let userURL = user_url;
      let location = await this.getAddress(selected_user);
      selected_user.location = location;
      const batch = db.batch();
      batch.update(
        db.doc(`user/${this.user_doc.id}/${this.source}/${selected_user.id}`),
        {
          "vaccine_verification_sent.date": moment()
            .startOf("day")
            .format("DDDD, MMM Do YYYY"),
        }
      );

      let deliveries = [];
      if (selected_user.email) {
        batch.update(
          db.doc(`user/${this.user_doc.id}/${this.source}/${selected_user.id}`),
          { "vaccine_verification_sent.email": fieldValue.serverTimestamp() }
        );
        deliveries.push(
          this.sendVerificationEmail({
            to_email: [
              {
                email: selected_user.email,
                type: "to",
              },
            ],
            company: this.user_doc.company,
            global_merge_vars: [
              {
                name: "logo",
                content: this.client.logo,
              },
              {
                name: "name",
                content: selected_user.first_name,
              },
              {
                name: "address",
                content: selected_user.location
                  ? selected_user.location.address_1
                  : this.locations[0].address_1,
              },
              {
                name: "city",
                content: selected_user.location
                  ? selected_user.location.city
                  : this.locations[0].city,
              },
              {
                name: "state",
                content: selected_user.location
                  ? selected_user.location.state
                  : this.locations[0].state,
              },
              {
                name: "zip",
                content: selected_user.location
                  ? selected_user.location.zip
                  : this.locations[0].zip,
              },
              {
                name: "phone",
                content: this.client.phone,
              },
              {
                name: "url",
                content: userURL,
              },
            ],
            message: null,
            uid: this.user_doc.id,
            fullName: `${selected_user.first_name} ${selected_user.last_name}`,
            employee_id: selected_user.employee_id,
          })
        );
      }
      return Promise.all(deliveries).then(() => batch.commit());
    },
    showImportPopup() {
      this.popupType = "import";
      this.showPopup = true;
    },
    showImportDeletePopup() {
      this.popupType = "bulk_delete";
      this.showPopup = true;
    },
    handleBulkEmployeeDelete() {
      this.showPopup = false;
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL",
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show({
            container: null,
            canCancel: false,
          });
          this.deleteBulkEmployees({
            employees: this.employeesConfirmedForDeletion,
            uid: this.user_doc.id,
          }).then((res) => {
            loader.hide();
            this.employeesToDelete = [];
            this.employeesConfirmedForDeletion = [];
            Swal.fire("Successfully deleted employees").then((res) => {
              window.location.reload();
            });
          });
        }
      });
    },
    showScheduledPopup() {
      this.popupType = "scheduled_all";
      this.showPopup = true;
    },
    inputFileToImport(event) {
      if (!event.target.files.length) {
        return false;
      }
      this.importLoading = true;
      let file = event.target.files[0];
      let reader = new FileReader();

      reader.readAsArrayBuffer(file);
      reader.onload = (e) => {
        this.loading = true;
        let data = e.target.result;
        data = new Uint8Array(data);
        this.importCSV({
          data: data,
          user_id: this.user_doc.id,
          source: this.source,
          location: this.selected_location,
          department: this.selected_department,
        })
          .then((res) => {
            this.loading = false;
            this.selected_location = null;
            this.popupType = "email";
            this.showPopup = false;
            this.importLoading = false;
            event.target.value = null;
            Swal.fire(
              "Import Completed",
              "Your data has been converted and saved",
              "success"
            );
          })
          .catch((err) => {
            this.importLoading = false;
            this.loading = false;
            this.selected_location = null;
            this.popupType = "email";
            this.showPopup = false;
            event.target.value = null;
            Swal.fire("Error!", "An error has occured: " + err, "error");
          });
      };
    },
    inputFileToImportDelete(event) {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      if (!event.target.files.length) {
        return false;
      }
      this.importLoading = true;
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = (e) => {
        this.loading = true;
        let data = e.target.result;
        data = new Uint8Array(data);
        this.getEmployeesToDeleteFromCSV({
          data: data,
          user_id: this.user_doc.id,
        }).then((res) => {
          if (res && res.data.length) {
            loader.hide();
            this.employeesToDelete = res.data;
            return this.showImportDeletePopup();
          } else {
            loader.hide();
            return Swal.fire(
              "Could find any employees match set of emails or phone numbers."
            );
          }
        });
      };
    },
    inputFileToExport() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });

      this.exportCSV({
        user: this.user_doc.id,
        isFiltered: this.isFiltered,
        filter_values: this.filter_values,
      }).then((res) => {
        let csvContent = res.data;
        let encodedUri = encodeURI(csvContent);
        let link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute(
          "download",
          `${this.client.name}-${this.source}s.csv`
        );
        document.body.appendChild(link); // Required for FF
        loader.hide();
        link.click();
      });
    },
    async handleVaccVerification() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });

      if (this.selected_users.length) {
        let promise_arr = this.selected_users.map(async (user, index) => {
          let userURL = `https://verified-survyio.web.app/${this.user_doc.id}/${user.id}`;
          return await this.sendVaccineVerificationEmail(user, userURL);
        });
        return Promise.all(promise_arr).then(() => {
          loader.hide();
          this.popupType = "email";
          this.loading = false;
          this.selected_users = [];
          return Swal.fire("Your verification forms has been sent");
        });
      }
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL",
      }).then((result) => {
        if (result.value) {
          return db
            .collection("user")
            .doc(this.user_doc.id)
            .collection(this.source)
            .doc(item.id)
            .delete()
            .then(() => {
              Swal.fire(
                "Deleted!",
                `The ${this.source} has been deleted.`,
                "success"
              ).then(() => {
                this.moveToPage(0);
              });
            });
        }
      });
    },
    deleteUsers() {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL",
      })
        .then((result) => {
          if (result.value) {
            let loader = this.$loading.show({
              container: null,
              canCancel: false,
            });
            let batch = db.batch();
            let deleted_users = this.selected_users.map(async (item) => {
              let ref = db
                .collection("user")
                .doc(this.user_doc.id)
                .collection(this.source)
                .doc(item.id);

              return batch.delete(ref);
            });

            return Promise.all([batch.commit()]).then(() => {
              this.selected_users = [];
              this.$refs.selectAll.checked = false;
              loader.hide();
            });
          }
        })
        .then(() => {
          this.moveToPage(0);
        });
    },
  },
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}

.title {
  font-size: 30px;
  font-weight: bold;
  font-family: "SFProDisplay", sans-serif;
  margin-top: 0;
  line-height: 1.2;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
  .img-btn {
    font-size: 13px;
    text-decoration: none;
    display: flex;
    align-items: center;
    @media screen and (max-width: 600px) {
      margin-top: 10px;
    }
    img {
      height: 16px;
      filter: brightness(0) invert(1);
      margin-right: 10px;
    }
  }
}

.full .v-select {
  max-width: 100%;
}

.holder .btn {
  margin-top: 20px;
}

.full {
  width: 100%;
}

.loader {
  height: 100px;
}

.btn-helper {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 999;
  .text_btn {
    padding: 0;
  }
  .helper {
    position: absolute;
    top: 15px;
    width: 100%;
    z-index: 99;
    background-color: white;
    box-shadow: 0 0 8px rgba(128, 128, 128, 0.35);
    p {
      font-size: 15px;
    }
  }
}

.mult-action {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid #eaeaea;
  background: #3bbf6f;
  position: fixed;
  z-index: 99999;
  width: 100%;
  left: 0;
  bottom: 0;
  justify-content: center;
  p {
    width: 100%;
    text-align: center;
    color: #ffffff;
    margin: 0;
    font-weight: bold;
    span {
      display: block;
      font-size: 15px;
      opacity: 0.7;
      font-weight: normal;
      margin-bottom: 10px;
    }
  }
  label {
    color: white;
  }
  .btn-img {
    align-items: center;
    display: flex;
    padding-left: 5px;
    img {
      height: 25px;
      margin-right: 10px;
    }
  }
}

.has-reminder {
  display: block;
  font-size: 13px;
  color: #3bbf6f;
  padding: 3px;
  margin-top: 5px;
  border-radius: 10px;
  text-align: center;
  font-weight: bold;
  background: rgba(59, 191, 111, 0.1);
}

.count {
  font-size: 12px;
  opacity: 0.7;
  margin-left: 5px;
}

.user_limit {
  opacity: 0.5;
  cursor: initial;
  span.count {
    opacity: 1;
  }
}

.filter .inputs {
  margin-bottom: 0;
  input {
    margin-bottom: 10px;
  }
}
</style>
